<template>
    <div>
        <nav-bar></nav-bar>
        <div class="content">
            <nav-left-bar :active="0"></nav-left-bar>
            <div class="rg">
                <div class="tit">
                    <div class="l">
                        <img src="../../assets/icon/bg.png" alt="" />
                        <div class="tc">{{ sourceList.meeting_info.name }}</div>
                    </div>
                </div>
                <div class="details">
                    <div class="title">
                        <div class="ricle"></div>
                        <div class="txt">
                            {{ sourceList.meeting_info.name }}
                        </div>
                    </div>
                    <div class="line"></div>
                    <div class="lk">
                        <img src="../../assets/icon/icon_gs.png" alt="" />
                        <div>
                            会议室归属：{{
                                sourceList.meeting_info.section_name
                            }}
                        </div>
                    </div>
                    <div class="lk">
                        <img src="../../assets/icon/details_2.png" alt="" />
                        <div>
                            会议室位置：{{ sourceList.meeting_info.address }}
                        </div>
                    </div>
                    <div class="lk">
                        <img src="../../assets/icon/details_3.png" alt="" />
                        <div>
                            会议室描述：{{ sourceList.meeting_info.content }}
                        </div>
                    </div>
                    <div class="lk">
                        <img
                            src="../../assets/icon/details_4.png"
                            alt=""
                            class=""
                        />
                        <div>会议室图片：</div>
                    </div>
                    <div class="lk">
                        <img
                            :src="sourceList.meeting_info.pic"
                            alt=""
                            class="eq"
                        />
                    </div>
                     <div class="lk">
                        <img src="../../assets/icon/details_1.png" alt="" />
                        <div>
                            会议室管理员：{{
                                sourceList.meeting_info.manager_name
                            }}
                        </div>
                    </div>
                    <div style="height:42px;"></div>
                    <div class="title">
                        <div class="ricle"></div>
                        <div class="txt">当前预约状况</div>
                    </div>
                    <div class="line"></div>

                    <!-- 选择插件 -->
                    <div style="height:32px"></div>
                    <month @findTime="findTime" :apply="apply" :status="1"></month>
                    <div style="height:42px;"></div>
                    <div class="title">
                        <div class="ricle"></div>
                        <div class="txt">温馨提示</div>
                    </div>
                    <div class="line"></div>

                    <div class="zhushi">
                        注：每个小块15分钟，蓝色表示已被预约，黄色表示审批中，绿色表示用户选择。
                    </div>
                    <div class="replay">
                        <div class="left" @click="applys">下一步</div>
                        <div class="right" @click="replay">预约记录</div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 预约记录 -->
        <div class="show" v-if="show"></div>
        <div class="ing" v-if="show">
            <div class="title">预约记录</div>
            <div class="list">
                <div class="li" v-for="(item, index) in applyList" :key="index">
                    <div class="top">
                        <div class="time">
                            {{ item.start_time_text }} ~
                            {{ item.end_time_text }}
                        </div>
                        <img
                            :src="
                                item.status_value == 2
                                    ? $global.Image.ing
                                    : item.status_value == 3
                                    ? $global.Image.no_ing
                                    : ''
                            "
                            alt=""
                        />
                    </div>
                    <div class="con">主题：{{ item.theme }}</div>
                    <div class="con">地点：{{ item.address }}</div>
                </div>
            </div>
              <img
            src="../../assets/icon/icon_close_x.png"
            alt=""
            class="close"
            v-if="show"
            @click="close"
        />
        </div>
      
    </div>
</template>
<script>
export default {
    name: "room_appointmentDetails",
    data() {
        return {
            value: "",
            currentPage: 10,
            show: false,
            time: "",
            sourceList: {
                meeting_info: {}
            },
            apply: {},
            applyList: []
        };
    },
    methods: {
        clear() {
            this.value = "";
        },
        replay() {
            if (this.applyList.length == 0) {
                this.$toast("暂无预约记录");
                return;
            }
            this.show = true;
        },
        close() {
            this.show = false;
        },
        applys() {
            this.$router.push({
                path: "/room_appointmentApply",
                query: {
                    id: this.$route.query.id
                }
            });
        },
        details() {
            let params = {
                time: this.time,
                id: this.$route.query.id
            };
            this.$post("/api/Meeting/meeting_info", params)
                .then(res => {
                    if ((res.code = 1)) {
                        let data = [],
                            data2 = [],
                            data3 = [],
                            data4 = [],
                            index = "",
                            index2 = "",
                            index3 = "",
                            index4 = "";
                        for (var i = 0; i < 24; i++) {
                            if (i < 10) {
                                index = "0" + i + ":15";
                                index2 = "0" + i + ":30";
                                index3 = "0" + i + ":45";
                                index4 = "0" + i + ":00";
                            } else {
                                index = i + ":15";
                                index2 = i + ":30";
                                index3 = i + ":45";
                                index4 = i + ":00";
                            }
                            data[i] = { time: index, type: 1, status: false };
                            data2[i] = { time: index2, type: 1, status: false };
                            data3[i] = { time: index3, type: 1, status: false };
                            data4[i] = { time: index4, type: 1, status: false };
                        }
                        var timestamp = new Date().valueOf(); //当前的时间戳
                        var date = new Date();
                        var y = date.getFullYear();
                        var m = date.getMonth() + 1;
                        m = m < 10 ? "0" + m : m;
                        var d = date.getDate();
                        d = d < 10 ? "0" + d : d;
                        var toTime = y + "-" + m + "-" + d; //当天的日期
                        console.log(toTime);
                        for (var i in data) {
                            for (var k in res.data.time) {
                                if (res.data.time[k].type == 1) {
                                    if (res.data.time[k].time == data[i].time) {
                                        data[i].type = 2; //审批中
                                    }
                                } else {
                                    if (res.data.time[k].time == data[i].time) {
                                        data[i].type = 3; //被预约
                                    }
                                }
                            }
                            let timeday = this.time == "" ? toTime : this.time;
                            let dat = new Date(
                                timeday + " " + data[i].time
                            ).getTime();
                            if (timestamp > dat) {
                                data[i].status = true;
                            }
                        }
                        for (var i in data2) {
                            for (var k in res.data.time) {
                                if (res.data.time[k].type == 1) {
                                    if (
                                        res.data.time[k].time == data2[i].time
                                    ) {
                                        data2[i].type = 2; //审批中
                                    }
                                } else {
                                    if (
                                        res.data.time[k].time == data2[i].time
                                    ) {
                                        data2[i].type = 3; //被预约
                                    }
                                }
                            }
                            let timeday = this.time == "" ? toTime : this.time;
                            let dat = new Date(
                                timeday + " " + data2[i].time
                            ).getTime();
                            if (timestamp > dat) {
                                data2[i].status = true;
                            }
                        }
                        for (var i in data3) {
                            for (var k in res.data.time) {
                                if (res.data.time[k].type == 1) {
                                    if (
                                        res.data.time[k].time == data3[i].time
                                    ) {
                                        data3[i].type = 2; //审批中
                                    }
                                } else {
                                    if (
                                        res.data.time[k].time == data3[i].time
                                    ) {
                                        data3[i].type = 3; //被预约
                                    }
                                }
                            }
                            let timeday = this.time == "" ? toTime : this.time;
                            let dat = new Date(
                                timeday + " " + data3[i].time
                            ).getTime();
                            if (timestamp > dat) {
                                data3[i].status = true;
                            }
                        }
                        for (var i in data4) {
                            for (var k in res.data.time) {
                                if (res.data.time[k].type == 1) {
                                    if (
                                        res.data.time[k].time == data4[i].time
                                    ) {
                                        data4[i].type = 2; //审批中
                                    }
                                } else {
                                    if (
                                        res.data.time[k].time == data4[i].time
                                    ) {
                                        data4[i].type = 3; //被预约
                                    }
                                }
                            }
                            let timeday = this.time == "" ? toTime : this.time;
                            let dat = new Date(
                                timeday + " " + data4[i].time
                            ).getTime();
                            if (timestamp > dat) {
                                data4[i].status = true;
                            }
                        }
                        let result = {
                            data: data,
                            data2: data2,
                            data3: data3,
                            data4: data4
                        };
                        this.sourceList = res.data;
                        this.apply = result;
                        // this.pass = res.data.pass;
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        },
        findTime(e) {
            this.time = e;
            this.details();
        },
        // 会议室记录
        record() {
            this.$post("/api/Meeting/meeting_appointment_list", {
                type_id: this.$route.query.id
            })
                .then(res => {
                    if (res.code == 1) {
                        this.applyList = res.data.data;
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        }
    },
    mounted() {
        this.details();
        this.record();
    }
};
</script>
<style lang="less" scoped>
.content {
    max-width: 1200px;
    margin: 0 auto;
    margin-top: 21px;
    display: flex;
    .rg {
        width: 838px;
        height: 80px;
        // line-height: 80px;
        background: #ffffff;
        margin-left: 21px;
        .tit {
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;
            .l {
                display: flex;
                height: 100%;
                align-items: center;
                img {
                    width: 5px;
                    height: 24px;
                }
                .tc {
                    font-size: 24px;
                    font-family: PingFangSC, PingFangSC-Medium;
                    font-weight: 500;
                    color: #333333;
                    padding-left: 13px;
                }
            }
        }
        .details {
            width: 838px;
            height: auto;
            background: #ffffff;
            margin-top: 21px;
            .title {
                display: flex;
                height: 43px;
                align-items: center;
                .ricle {
                    width: 4px;
                    height: 4px;
                    background: #ffffff;
                    border: 3px solid #3449d3;
                    border-radius: 50%;
                    margin-left: 20px;
                }
                .txt {
                    font-size: 18px;
                    font-family: PingFangSC, PingFangSC-Medium;
                    font-weight: 500;
                    text-align: left;
                    color: #333333;
                    padding-left: 14px;
                }
            }
            .line {
                width: 793px;
                border: 1px dashed #eaecfa;
                margin-left: 20px;
            }
            .lk {
                display: flex;
                padding-left: 20px;
                padding-top: 20px;
                img {
                    // width: 18px;
                    height: 18px;
                }
                > div {
                    max-width: 745px;
                    font-size: 16px;
                    font-family: PingFangSC, PingFangSC-Regular;
                    font-weight: 400;
                    text-align: left;
                    color: #333333;
                    line-height: 20px;
                    padding-left: 14px;
                }
                .eq {
                    width: 290px !important;
                    height: 190px !important;
                    margin-left: 27px;
                    // object-fit: cover;
                }
            }
            .zhushi {
                font-size: 16px;
                font-family: PingFangSC, PingFangSC-Regular;
                font-weight: 400;
                text-align: left;
                color: #333333;
                padding: 27px 0 60px 40px;
            }
            .replay {
                display: flex;
                height: 44px;
                align-items: center;
                width: 100%;
                justify-content: center;
                padding-bottom: 60px;
                .left {
                    width: 346px;
                    height: 44px;
                    line-height: 44px;
                    text-align: center;
                    background: #3449d3;
                    border-radius: 5px;
                    color: #ffffff;
                    font-size: 16px;
                    margin-right: 50px;
                    cursor: pointer;
                }
                .right {
                    width: 346px;
                    height: 44px;
                    line-height: 44px;
                    text-align: center;
                    background: #6480ec;
                    border-radius: 5px;
                    color: #ffffff;
                    font-size: 16px;
                    cursor: pointer;
                }
            }
        }
    }
}
.show {
    position: fixed;
    z-index: 11;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: #333333;
    opacity: 0.5;
    width: 100%;
    height: 100%;
}
.close {
    width: 50px;
    height: 50px;
    position: fixed;
    // left: 0;
    // right: 28%;
    z-index: 111;
    top: 16%;
    margin-left: 30px;
    // margin: 0 auto;
    cursor: pointer;
}
.ing {
    width: 640px;
    height: 466px;
    background: #ffffff;
    border-radius: 6px;
    box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.19);
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    z-index: 1000;
    .title {
        width: 100%;
        height: 81px;
        line-height: 81px;
        background: #f3f5fc;
        border-radius: 6px 6px 0px 0px;
        text-align: center;
        font-size: 24px;
        font-family: PingFangSC, PingFangSC-Medium;
        font-weight: 500;
        color: #333333;
    }
    .list {
        width: 100%;
        height: 356px;
        overflow-y: scroll;
        // display: flex;
        flex-direction: column;
        align-items: center;
        display: -webkit-inline-box;
        .li {
            width: 100%;
            min-height: 90px;
            display: flex;
            justify-content: center;
            flex-direction: column;

            border-bottom: 1px solid #f8f8f8;
            .top {
                display: flex;
                align-items: center;
                .time {
                    font-size: 16px;
                    font-family: PingFangSC, PingFangSC-Medium;
                    font-weight: 500;
                    color: #333333;
                    letter-spacing: 0px;
                    padding-left: 50px;
                    padding-top: 5px;
                }

                img {
                    width: 69px;
                    height: 25px;
                    margin-left: 100px;
                    // position: absolute;
                    right: 30px;
                    margin-top: 5px;
                }
            }
            .con {
                font-size: 16px;
                font-family: PingFangSC, PingFangSC-Medium;
                font-weight: 400;
                color: #333333;
                letter-spacing: 0px;
                text-align: left;
                padding-left: 50px;
                padding-top: 5px;
                padding-bottom: 5px;
                max-width: 500px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
        }
    }
}
</style>
